import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ButtonGroup',
    props: {
        width: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["themeButtonGroup", { [`width--${_ctx.width}`]: _ctx.width }])
            }, [
                _renderSlot(_ctx.$slots, "default")
            ], 2));
        };
    }
});
